<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.mode === mode.add ? data.sysText.employeeEntitlement_add : data.sysText.employeeEntitlement_edit }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
  <mat-divider class="section-header-underline"></mat-divider>
</div>

<mat-dialog-content>
  <ng-container>
    <form [formGroup]="form">
      <app-date-field
        [label]="data.sysText.employeeEntitlement_effectiveDate"
        [control]="form.controls.effectiveDate"
        [icon]="'calendar_today'"
        [group]="form"
        [hint]="data.sysText.workSchedule_effectiveDateHint"
        [isHintHighlighted]="false"
        [info]="data.sysText.workSchedule_effectiveDate_Info">
      </app-date-field>
      <app-select-field
        [control]="form.controls.bank"
        [label]="data.sysText.employeeEntitlement_bank"
        [options]="bankOptions"
        [icon]="'move_to_inbox'"
        [shouldCapitalize]="false">
      </app-select-field>
      <app-input-field
        [control]="this.form.controls.bankHours"
        [icon]="'schedule'"
        [label]="data.sysText.employeeEntitlement_totalHours"
        [inputType]="'number'"
        [removeLabelCasePipe]="true">
      </app-input-field>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.mode === mode.add ? data.sysText.add : data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

